import { Component, Input } from '@angular/core';

/**
 * Generated class for the CoLocationImageComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-location-image',
  templateUrl: 'co-location-image.html',
  inputs: ['locationImg', 'parentKeyword']
})
export class CoLocationImageComponent {
  @Input('locationImg') locationImg : any;
  @Input('parentKeyword') parentKeyword: any;
  constructor() {

  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    // console.log(this.locationImg, this.parentKeyword);
    if (this.locationImg) this.locationImg = encodeURIComponent(this.locationImg);
  }
}


// WEBPACK FOOTER //
// ./src/components/co-location-image/co-location-image.ts